import { withApiContext, withLabelsContext, withUserContext } from "context";
import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import style from "./Campaign.module.scss";
import { Checkbox, Textarea, Button } from "components";
import FormField from "components/FormField";
import {IconClose} from "Icons";
import { useTheme } from "styled-components";
import { rgba } from "polished";

const CampaignModal = (props) => {
  const [modalOpen, setModalOpen] = useState(true);
  const [eventData, setEventData] = useState({});

  const theme = useTheme();
  const inlineBackground = {
    "--bg-color-1": theme.primary,
    "--bgColor":rgba(theme.primary, 0.5)
  };


  useEffect(() => {
    const {user} = props.ctx_user;
    const getPromotionDetails = async() => {
      const {rsp} = await props.ctx_api.privateRequest({
        cmd: "get_master_event_details",
        args: {
          goiId: user.goiId,
          organizationId: user.organizationId
        }
      })

      if(rsp){
        setEventData(rsp[0]);
      }
    }
    getPromotionDetails();
  }, [])

  const handleHideModal = () => {
    setModalOpen(false);
    props.onClose();
  };

  
  const handleRedirect = () => {
    window.open (eventData.post_url, "_blank");
      }


    const insertEventTransaction =  async() => {
     const {rsp}  = await props.ctx_api
      .privateRequest({
        cmd: "insert_event_transactions",
        args:{
          eventId:eventData.event_id
        }
      })
      if(rsp.StatusValue === 1){
        props.onButtonClick();
       } 
       if(eventData.post_url === null || eventData.post_url ===""){
        handleHideModal()
       } else {
        handleRedirect();
        setModalOpen(false);
       }
    };



    const HighlightHashtags = ({ text }) => {
      const words = text.split(/(\s+)/);
      
      return (
        <div>
          <div>
            {words.map((word, index) => 
              !word.startsWith('#') ? word : null
            )}
          </div>
         <div>
            {words.map((word, index) =>
              word.startsWith('#') ? (
                <span key={index} className={style.highlightWord}>
                  {word}{' '}
                </span>
              ) : null
            )}
         </div>
        </div>
      );
    };
    

  const photo = "https://images.ilearningengines.net/images/modalImage.png";

  const isMobile = window.innerWidth <= 575;

  const renderModal = () => {
    return (
       props.ctx_user.user && (
      <Modal
        backdrop="static"
        show={modalOpen}
        onHide={handleHideModal}
        scrollable={true}
        size={isMobile ? "sm" : ""}
        centered
        dialogClassName={!isMobile ?style.modalWrapper: ""}
        contentClassName={!isMobile ? style.modalBody: ""}
      >
        <Modal.Body
          closeButton={true}
          style={{ padding: "10px" }}
        >
          <div className={style.contentWrapper}>
            <div  className={style.headerContent}>
            <div className={style.postHeader}>{eventData.event_name}</div>
            <div className={style.closeButton} onClick={handleHideModal}  style={inlineBackground}>
              <IconClose />
            </div>
            </div>
              <div className={style.postContainer}>
              <div className={isMobile ? style.mobilePostContent : style.postContent} style={inlineBackground}><HighlightHashtags text={eventData.event_description} /></div>
              <div className={isMobile? style.mobileModalImage : style.postImage}>
                <img src={eventData.post_image === "" ? photo : eventData.post_image} alt="" />
              </div>
              </div>
            <div className={style.bottomButton}>
            <Button  className= "rectangle-btn" onClick ={insertEventTransaction}>
              {eventData.button_text.length > 30 ? eventData.button_text.slice(0, 30) + "..." : eventData.button_text}
              </Button>
            </div>
            </div>
        </Modal.Body>
      </Modal>
    )
    );
  };

  return <div> {eventData.event_id && renderModal()}</div>;
  };

export default withApiContext(
  withLabelsContext(withUserContext(CampaignModal))
);
